import React, { type ComponentType } from 'react';
import '@atlaskit/css-reset';
import PageAppInitialisationAnalytics from '@atlassian/jira-common-analytics-page-app-initialisation';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';
import { SubProductUpdater } from '@atlassian/jira-spa-apps-common/src/analytics-sub-product/sub-product-updater/index.tsx';
import SpaErrorBoundary from '@atlassian/jira-spa-apps-common/src/error-boundary';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import { withRouter } from '@atlassian/react-resource-router';
import View from './ui';
import { METRICS_PAGE_ID, issueTypeSchemesDirectoryPageLoad } from './utils/performance-analytics';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const RouterWrapper: ComponentType<Record<any, any>> = withRouter(View);

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
export default (props: Record<any, any>) => (
	<>
		<MarkProductStart />
		<SpaErrorBoundary id={`spa-app-bootstrap.${METRICS_PAGE_ID}`}>
			<SubProductUpdater subProduct="platform" />
			<PageAppInitialisationAnalytics
				appNameSuffixForV2Event={METRICS_PAGE_ID}
				appNameForV3OperationalEvent="issueTypeSchemesDirectoryAdmin"
			/>
			<RouterWrapper {...props} />
			<SpaStatePageReady />
			{/* @ts-expect-error - TS2769 - No overload matches this call. */}
			<SubmitApdex appName={METRICS_PAGE_ID} metric={issueTypeSchemesDirectoryPageLoad} />
		</SpaErrorBoundary>
	</>
);
